<section class="toast-wrap">
    {{message()}}
</section>